import { useTranslation } from "react-i18next";
import "./style.css";
import introduceHeroImage from "../../assets/banner/introduce/banner.png";

const Introduce = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero Section - Giới thiệu chung */}
      <section className="introduce-hero" style={{ backgroundImage: `url(${introduceHeroImage})` }}>
        <div className="introduce-hero-content">
          {/* <div className="hero-emoji">🌐</div> */}
          <h1 className="font-bauhaus-medium">{t("introduction.hero.title")}</h1>
          <div className="hero-description">
            <p className="font-tomorrow">{t("introduction.hero.description1")}</p>
            <p className="font-tomorrow">{t("introduction.hero.description2")}</p>
          </div>
        </div>
      </section>

      {/* Vision Mission Values Section */}
      <section className="introduce-vision-section">
        <div className="introduce-content-container">
          <div className="section-header">
            {/* <div className="header-emoji">🔭</div> */}
            <h2 className="section-title font-bauhaus-medium">
              {t("introduction.vision.sectionTitle")}
            </h2>
          </div>
          
          <div className="vision-grid">
            {/* Tầm nhìn */}
            <div className="vision-card">
              <div className="vision-label font-tomorrow">
                {t("introduction.vision.label")}
              </div>
              <p className="vision-description font-tomorrow">
                {t("introduction.vision.description")}
              </p>
            </div>

            {/* Sứ mệnh */}
            <div className="vision-card">
              <div className="vision-label font-tomorrow">
                {t("introduction.mission.label")}
              </div>
              <p className="vision-description font-tomorrow">
                {t("introduction.mission.description")}
              </p>
            </div>
          </div>

          {/* Giá trị cốt lõi */}
          <div className="values-section">
            <h3 className="values-title font-tomorrow">
              {t("introduction.values.title")}
            </h3>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-number">01</div>
                <h4 className="font-tomorrow">{t("introduction.values.value1")}</h4>
              </div>
              <div className="value-card">
                <div className="value-number">02</div>
                <h4 className="font-tomorrow">{t("introduction.values.value2")}</h4>
              </div>
              <div className="value-card">
                <div className="value-number">03</div>
                <h4 className="font-tomorrow">{t("introduction.values.value3")}</h4>
              </div>
              <div className="value-card">
                <div className="value-number">04</div>
                <h4 className="font-tomorrow">{t("introduction.values.value4")}</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Message Section */}
      <section className="introduce-brand-message">
        <div className="brand-message-content">
          {/* <div className="message-emoji">💬</div> */}
          <h2 className="brand-message-title font-bauhaus-medium">
            {t("introduction.brandMessage.title")}
          </h2>
          <p className="brand-message-text font-tomorrow">
            {t("introduction.brandMessage.description1")}
          </p>
          <div className="brand-message-highlight font-tomorrow">
            <p style={{ margin: 0, marginBottom: '0.5rem' }}>
              {t("introduction.brandMessage.description2")}
            </p>
            <p style={{ margin: 0 }}>
              {t("introduction.brandMessage.description3")}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Introduce;
